import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import { TextFieldControl } from '@cbridge-tools/field';
import { INodeForm } from '@cbridge-packages/node';

export const NodeForm: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Grid container={true} rowSpacing={2} columnSpacing={2}>
      <Grid size={12}>
        <TextFieldControl<INodeForm, 'name'>
          label={t('text:entity.symbolPool.nodeName.label')}
          name={'name'}
          required={true}
        />
      </Grid>
    </Grid>
  );
};
